import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult, IRequestResult } from "app/common/interfaces";
import { andAllWhere, andWhere, buildQuery, CombinedFilter, Ops, orderBy, OrderVariant, orWhere, page, select, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ICreateVehicleType, IUpdateVehicleType } from "./interfaces/type-vechicle.interface";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import VehicleTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity";
import { RequestOptions } from '../../../../common/interfaces/options.interface';

const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "vehicle-type";

@Injectable({
  providedIn: "root",
})
export class VehicleTypeService extends AbstractService<VehicleTypeAttributes, ICreateVehicleType, IUpdateVehicleType> {

    /** The last filter used to load the list */
    currentFilter: CombinedFilter<VehicleTypeAttributes>;

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * List
     * @param filter CombinedFilter of related entity - VehicleTypeAttributes
     * @returns Data list
     */
    getAllPaginateVehicleType( 
        options: IPagination<VehicleTypeAttributes> & { companyId?: string; status?: number[] }
    ): Observable<IPaginationResult<VehicleTypeAttributes>> {
        const query = buildQuery<VehicleTypeAttributes>(
            where('_deleted', Ops.eq(false)),
            andWhere("code", Ops.like(options.search ?? "", "i")),
            orWhere("name", Ops.like(options.search ?? "", "i")),
            andAllWhere("company.id" as keyof VehicleTypeAttributes, Ops.eq(options.companyId ?? "")),
            andAllWhere("statusId", Ops.in(...options?.status ?? [])),
            orderBy(
                options.sort ?? "name",
                options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
            ),
            page(options.currentPage ?? 1, options.limitPerPage ?? 100)
        );

        this.currentFilter = query;
        
        const API_URL: string = apiUrl + 
            `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
        return this.http.get<IPaginationResult<VehicleTypeAttributes>>(API_URL);
    }

    /**
     * Find to combo box
     * @returns Data
    */
    findToComboBox(type?): Observable<IRequestResult<VehicleTypeAttributes[]>> {
        const query = buildQuery<VehicleTypeAttributes>(
            where("statusId", StatusEnum.ACTIVE),
            select(["code", "name"]),
            orderBy("code", OrderVariant.Asc)
        );

        const API_URL: string =
            apiUrl +
            `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
        return this.http.get<IRequestResult<VehicleTypeAttributes[]>>(API_URL);
    }

     findByFilter(filter: CombinedFilter<VehicleTypeAttributes>, options?: RequestOptions) {
        const API_URL: string =
          apiUrl +
          `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(filter))}`;
          const headers: Record<string, any> = {};
          // see order-customer-export for more info about this header
          // ctx: stands for context
          if (options?.contextHeader) headers['x-ave-ctx'] = options.contextHeader;
          return this.http.get<IPaginationResult<VehicleTypeAttributes>>(API_URL, { headers });
      }
}
